export const model = {
    id: null,
    name      : '',
    surname   : '',
    patronymic: '',
    email     : '',
    phone     : '',
    gender    : '',
    last_login: '',
};